export const SearchParams = {
    Type: 'type',
    Flag: 'flag',
    Id: 'id',
}